/*
* Pipeline Theme — Parla Oral Care customisations
*
* Custom JS lives here so it survives theme updates.
* Loaded via layout/theme.liquid (custom.js script tag must be uncommented there).
*/

(function () {

  /* =========================================================
     FREE GIFT: Paste Press Key with any 3-pack or Discovery Kit

     Works alongside a "Buy X Get Y" automatic discount in Shopify admin
     that makes the Key £0 when a qualifying product is in the cart.
     JS handles adding/removing the item; Shopify handles the pricing.
     ========================================================= */

  const FREE_GIFT_VARIANT_ID = 55548751446395; // Paste Press Toothpaste Key — Default Title variant

  const QUALIFYING_PRODUCT_IDS = [
    15161007964539, // Toothpaste Discovery Kit
    15158916710779, // Bio Balance Toothpaste x3
    15158915694971, // Enamel Protect Toothpaste x3
    15157001257339, // Pro Whitening Toothpaste x3
  ];

  const FREE_GIFT_PRODUCT_ID = 15140362551675; // Paste Press Toothpaste Key
  const FREE_GIFT_PROP = '_is_free_gift';

  let isSyncing = false;

  function cartHasQualifier(cart) {
    return cart.items.some(item => QUALIFYING_PRODUCT_IDS.includes(item.product_id));
  }

  function cartHasFreeGift(cart) {
    return cart.items.some(
      item => item.product_id === FREE_GIFT_PRODUCT_ID
    );
  }

  async function addFreeGift() {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: FREE_GIFT_VARIANT_ID,
        quantity: 1,
        properties: { [FREE_GIFT_PROP]: 'true' },
      }),
    });
    if (!res.ok) throw new Error('Failed to add free gift');
  }

  async function syncFreeGift(cart) {
    if (isSyncing || !FREE_GIFT_VARIANT_ID) return;
    isSyncing = true;

    try {
      const hasQualifier = cartHasQualifier(cart);
      const hasGift = cartHasFreeGift(cart);

      if (hasQualifier && !hasGift) {
        await addFreeGift();
        document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
      }
    } catch (err) {
      console.error('[Parla] Free gift sync error:', err);
    } finally {
      isSyncing = false;
    }
  }

  document.addEventListener('theme:cart:change', function (e) {
    if (isSyncing) return;
    const cart = e.detail && e.detail.cart;
    if (cart) syncFreeGift(cart);
  });

  document.addEventListener('theme:cart:init', function (e) {
    if (isSyncing) return;
    const cart = e.detail && e.detail.cart;
    if (cart) syncFreeGift(cart);
  });

  /* =========================================================
     END free gift logic
     ========================================================= */

})();
